import { fg } from '@atlaskit/platform-feature-flags/fg';
import { ROVO_PUBLISH_AGENT_KEY } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

export const isRovoPublishAgentAction = (action: Pick<MessageAction, 'key'>): boolean =>
	action.key === ROVO_PUBLISH_AGENT_KEY && fg('sltns-1529-draft-agent-non-consequential');
